import "@/App.css";
import {
  BrowserRouter,
  Navigate,
  Route,
  Routes,
  useLocation,
} from "react-router-dom";
import { Toaster } from "sonner";

import ProtectedDashboard from "@/components/ProtectedDashboard";
import ProtectedInventory from "@/components/ProtectedInventory";
import ProtectedAdmin from "@/components/ProtectedAdmin";
import ProtectedCatalog from "@/components/ProtectedCatalog";
import ProtectedImportReview from "@/components/ProtectedImportReview";
import ProtectedImportCenter from "@/components/ProtectedImportCenter";
import ProtectedWorkspace from "@/components/ProtectedWorkspace";
import AuthCallback from "@/pages/AuthCallback";
import AcceptInvitePage from "@/pages/AcceptInvitePage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import LoginPage from "@/pages/LoginPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import IntakeWorkspacePage from "@/pages/IntakeWorkspacePage";
import SetLibraryPage from "@/pages/SetLibraryPage";

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/accept-invite" element={<AcceptInvitePage />} />
      <Route path="/dashboard" element={<ProtectedDashboard />} />
      <Route path="/inventory" element={<ProtectedInventory />} />
      <Route
        path="/sets"
        element={<ProtectedWorkspace PageComponent={SetLibraryPage} />}
      />
      <Route
        path="/intake"
        element={<ProtectedWorkspace PageComponent={IntakeWorkspacePage} />}
      />
      <Route path="/admin" element={<ProtectedAdmin />} />
      <Route path="/admin/catalog" element={<ProtectedCatalog />} />
      <Route path="/admin/import-center" element={<ProtectedImportCenter />} />
      <Route
        path="/site-admin/import-review"
        element={<ProtectedImportReview />}
      />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
